<div class="card card-table">
  <div class="card-body">
    <table class="table table-hover table-center">
      <thead>
        <tr>
          <th style="min-width: 200px;">Vaccin<button class="openDialoge" [title]="'Ajouter Vaccin'" (click)="drawerActive = !drawerActive"><i class="fa-sharp fas fa-syringe"></i></button></th>
          <th>Date</th>
          <th>Numéro de Lot</th>
          <th style="min-width: 80px;">Notes</th>
          <th style="min-width: 80px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let vaccinesConsultationItem of vaccinesConsultationItems;let i = index">
          <td >
            <app-vaccinaion-drop-down-select [(value)]="vaccinesConsultationItem.vaccin" [placeHolder]="'Vaccin is here'"
              (valueChange)="_change()"></app-vaccinaion-drop-down-select>
            <div *ngIf="validateConsultationItem(vaccinesConsultationItem).controlsValidation['vaccin'] == 'required'  && submitted">
              <span style="color: red;">Vaccin est obligatoire </span>
            </div>
          </td>
          <td>
                                <date-picker [(ngModel)]="vaccinesConsultationItem.date_consultation_vaccin"></date-picker>

          
          </td>
          <td>
            <textarea style="height: 45px;" [(ngModel)]="vaccinesConsultationItem.numLot_consultation_vaccin" (ngModelChange)="_change()" class="form-control"></textarea>
           
          </td>
          <td>
            <textarea style="height: 45px;" [(ngModel)]="vaccinesConsultationItem.note_consultation_vaccin" class="form-control"></textarea>
          </td>
          <td>
            <a class="btn bg-danger-light trash" (click)="deletePrescriptionItem(i)"><i class="feather-trash-2"></i></a>
          </td>
        </tr>
        <tr>
          <td colspan="5">
            <div class="add-more-item text-center">
              <a href="javascript:void(0);" (click)="addConsultationVaccinationItem()"><i class="feather-plus-circle"></i> Ajouter </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-drawer [active]="drawerActive" [title]="'Ajouter Vaccin'">
    <div body style="height: 80%;">
        <app-vaccin-select-drawer  [(values)]="vaccines"
        (valuesChange)="_change()" (closed)="closed()" [(vaccinsSelected)]="vaccinfilter"></app-vaccin-select-drawer>
      <!-- <app-doctor-patient-historics *ngIf="consultation.appointment.patient.id.length" [patientId]="consultation.appointment.patient.id"></app-doctor-patient-historics> -->
    </div>
  </app-drawer>
